import React from "react";
// import * as OidcManager from "./security/OidcManager";
import RoutesConfig from "./routing/RoutesConfig";
import { Layout, Space, FloatButton } from 'antd';
import { Link, useLocation, useNavigate } from "react-router-dom";
import history from "./support/HttpService";
import { Provider } from "./components/context";

const App = () => {
    
    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    // init custom history object to allow navigation from
    // anywhere in the react app (inside or outside components)

    history.navigate = useNavigate();
    history.location = useLocation();

    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // A partir de este punto, estamos autenticados. Toda llamada a los backends incluyen el access token
    // que indica quien es el que realiza la invocacion

    const { Header, Footer, Content } = Layout;

    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////    

    return (
        <Provider>
            <Layout className="layout">
            <Header>
                <div className="logo">
                    <Link to={"/"}>
                        <img
                            src="##CONTEXTO##/images/logo.png"
                            alt={"ScotiaBank"}
                            title={"ScotiaBank"}
                            width="194"
                            height="64"
                        />
                    </Link>
                </div>

                <Space wrap style={{ display: 'flex', justifyContent: 'space-between' }}>
                </Space>
            </Header>

            <Content style={{ paddingTop: '0px', paddingBottom: '0px', paddingLeft: '50px', paddingRight: '50px' }}>
                <RoutesConfig />
            </Content>

            <Footer style={{ textAlign: 'center' }}>
                {/* © Copyright {new Date().getFullYear()} - TEMPLATE */}
            </Footer>
            <FloatButton.BackTop description={'Arriba'} />
        </Layout>
        </Provider>
    );
}


export default App;
